var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("@/assets/404_images/404.png"),"alt":""}}),_c('p',[_vm._v("您要访问的页面已丢失")])])}]

export { render, staticRenderFns }